/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo } from 'react';
import {
  CoreFilterableSelect,
  CoreFilterableSelectProps,
  ValidationProps,
} from '@amzn/dots-core-ui';
import { useQuery } from 'react-query';
import Alert from '@amzn/meridian/alert';
import { useClient } from '$/api';

export type GroupSelectProps = Pick<
  ValidationProps<CoreFilterableSelectProps>,
  'value' | 'onChange' | 'errorMessage' | 'validationState'
>;

export const GroupSelect = ({
  validationState,
  ...rest
}: GroupSelectProps): JSX.Element => {
  const { groups } = useClient();
  const { data, isLoading, isError, error } = useQuery<string[], Error>(
    'groups',
    async () => {
      const response = await groups.getAll();
      return response.content.map((item) => item.name);
    }
  );
  const items = useMemo(() => data ?? [], [data]);
  if (isError) {
    return (
      <Alert type="error" title="Failed to get Groups">
        {error?.message}
      </Alert>
    );
  }
  return (
    <CoreFilterableSelect
      {...rest}
      label="Owner"
      items={items}
      disabled={isLoading}
      validationState={isLoading ? 'validating' : validationState}
    />
  );
};
